export default __webpack_public_path__ + "images/g2alogo-22b4d24b693a2f47d98464b372957271.svg";